import {
  FETCH_TOEGANGSCONTROLES,
  FETCH_TOEGANGSCONTROLE,
  SAVE_TOEGANGSCONTROLE,
  TOGGLE_TOEGANGSCONTROLE,
  TEST_TOEGANGSCONTROLE,
  START_AUTHORIZATION,
  REFRESH_TOKEN,
  TOEGANGSCONTROLE_ERROR,
  FETCH_DOORSY_RESERVATIONS,
  FETCH_DOORSY_RESERVATION,
  SYNC_DOORSY_RESERVATIONS,
  TEST_DOORSY_CONNECTION,
  FETCH_DOORSY_USER_INFO,
  FETCH_DOORSY_SYSTEM_INFO,
  FETCH_DOORSY_REALESTATES,
  CREATE_DOORSY_REALESTATE,
  DOORSY_ERROR,
  CREATE_TOEGANGSCODE,
  FETCH_TOEGANGSCODES,
  FETCH_TOEGANGSCODE,
  DEACTIVEER_TOEGANGSCODE,
  DELETE_TOEGANGSCODE,
  VALIDATE_TOEGANGSCODE,
  TOEGANGSCODE_ERROR
} from "./types";

const API_URL = "/api/admin/toegangscontrole";
const DOORSY_API_URL = "/api/admin/doorsy";
const TOEGANGSCODE_API_URL = "/api/admin/toegangscodes";

function handleResponse(response) {
  if (response.ok) {
    return response.json();
  } else {
    let error = new Error(response.statusText);
    error.response = response.statusText;
    throw error;
  }
}

// Haal alle toegangscontrole configuraties op
export const fetchToegangscontroles = () => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(API_URL, {
      method: 'GET',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      }
    });
    
    const data = await handleResponse(response);
    
    dispatch({
      type: FETCH_TOEGANGSCONTROLES,
      payload: data.results
    });
    
    return data;
  } catch (error) {
    dispatch({
      type: TOEGANGSCONTROLE_ERROR,
      payload: error.message || "Fout bij ophalen toegangscontrole configuraties"
    });
    
    return { type: "TOEGANGSCONTROLE_ERROR", error: error.message };
  }
};

// Haal specifieke toegangscontrole configuratie op
export const fetchToegangscontrole = (id) => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(`${API_URL}/${id}`, {
      method: 'GET',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      }
    });
    
    const data = await handleResponse(response);
    
    dispatch({
      type: FETCH_TOEGANGSCONTROLE,
      payload: data.result
    });
    
    return data;
  } catch (error) {
    dispatch({
      type: TOEGANGSCONTROLE_ERROR,
      payload: error.message || "Fout bij ophalen toegangscontrole configuratie"
    });
    
    return { type: "TOEGANGSCONTROLE_ERROR", error: error.message };
  }
};

// Opslaan toegangscontrole configuratie
export const saveToegangscontrole = (configData) => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(API_URL, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(configData)
    });
    
    const data = await handleResponse(response);
    
    dispatch({
      type: SAVE_TOEGANGSCONTROLE,
      payload: data.result
    });
    
    return data;
  } catch (error) {
    dispatch({
      type: TOEGANGSCONTROLE_ERROR,
      payload: error.message || "Fout bij opslaan toegangscontrole configuratie"
    });
    
    return { type: "TOEGANGSCONTROLE_ERROR", error: error.message };
  }
};

// Schakel toegangscontrole in/uit
export const toggleToegangscontrole = (id) => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(`${API_URL}/${id}/toggle`, {
      method: 'PUT',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      }
    });
    
    const data = await handleResponse(response);
    
    dispatch({
      type: TOGGLE_TOEGANGSCONTROLE,
      payload: data.result
    });
    
    return data;
  } catch (error) {
    dispatch({
      type: TOEGANGSCONTROLE_ERROR,
      payload: error.message || "Fout bij schakelen toegangscontrole"
    });
    
    return { type: "TOEGANGSCONTROLE_ERROR", error: error.message };
  }
};

// Start OAuth Authorization Flow
export const startAuthorizationFlow = (id) => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(`${API_URL}/${id}/authorize`, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      }
    });
    
    const data = await handleResponse(response);
    
    dispatch({
      type: START_AUTHORIZATION,
      payload: data
    });
    
    // Open authorization URL in new window
    if (data.authorization_url) {
      window.open(data.authorization_url, '_blank', 'width=600,height=700');
    }
    
    return data;
  } catch (error) {
    dispatch({
      type: TOEGANGSCONTROLE_ERROR,
      payload: error.message || "Fout bij starten authorization flow"
    });
    
    return { type: "TOEGANGSCONTROLE_ERROR", error: error.message };
  }
};

// Test toegangscontrole configuratie
export const testToegangscontrole = (id) => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(`${API_URL}/${id}/test`, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      }
    });
    
    const data = await handleResponse(response);
    
    dispatch({
      type: TEST_TOEGANGSCONTROLE,
      payload: data.test_result
    });
    
    return data;
  } catch (error) {
    dispatch({
      type: TOEGANGSCONTROLE_ERROR,
      payload: error.message || "Fout bij testen toegangscontrole"
    });
    
    return { type: "TOEGANGSCONTROLE_ERROR", error: error.message };
  }
};

// Refresh access token
export const refreshToken = (id) => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(`${API_URL}/${id}/refresh-token`, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      }
    });
    
    const data = await handleResponse(response);
    
    dispatch({
      type: REFRESH_TOKEN,
      payload: data.result
    });
    
    return data;
  } catch (error) {
    dispatch({
      type: TOEGANGSCONTROLE_ERROR,
      payload: error.message || "Fout bij vernieuwen token"
    });
    
    return { type: "TOEGANGSCONTROLE_ERROR", error: error.message };
  }
};

// =============== DOORSY API ACTIONS ===============

// Haal Doorsy reserveringen op
export const fetchDoorsyReservations = (filters = {}) => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    const queryParams = new URLSearchParams(filters).toString();
    const url = queryParams ? `${DOORSY_API_URL}/reservations?${queryParams}` : `${DOORSY_API_URL}/reservations`;
    
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      }
    });
    
    const data = await handleResponse(response);
    
    dispatch({
      type: FETCH_DOORSY_RESERVATIONS,
      payload: data.data
    });
    
    return data;
  } catch (error) {
    dispatch({
      type: DOORSY_ERROR,
      payload: error.message || "Fout bij ophalen Doorsy reserveringen"
    });
    
    return { type: "DOORSY_ERROR", error: error.message };
  }
};

// Haal specifieke Doorsy reservering op
export const fetchDoorsyReservation = (reservationId) => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(`${DOORSY_API_URL}/reservations/${reservationId}`, {
      method: 'GET',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      }
    });
    
    const data = await handleResponse(response);
    
    dispatch({
      type: FETCH_DOORSY_RESERVATION,
      payload: data.data
    });
    
    return data;
  } catch (error) {
    dispatch({
      type: DOORSY_ERROR,
      payload: error.message || "Fout bij ophalen Doorsy reservering"
    });
    
    return { type: "DOORSY_ERROR", error: error.message };
  }
};


// Synchroniseer Doorsy reserveringen
export const syncDoorsyReservations = () => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(`${DOORSY_API_URL}/sync-reservations`, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      }
    });
    
    const data = await handleResponse(response);
    
    dispatch({
      type: SYNC_DOORSY_RESERVATIONS,
      payload: data
    });
    
    return data;
  } catch (error) {
    dispatch({
      type: DOORSY_ERROR,
      payload: error.message || "Fout bij synchroniseren Doorsy reserveringen"
    });
    
    return { type: "DOORSY_ERROR", error: error.message };
  }
};

// Test Doorsy verbinding
export const testDoorsyConnection = () => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(`${DOORSY_API_URL}/test-connection`, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      }
    });
    
    const data = await handleResponse(response);
    
    dispatch({
      type: TEST_DOORSY_CONNECTION,
      payload: data
    });
    
    return data;
  } catch (error) {
    dispatch({
      type: DOORSY_ERROR,
      payload: error.message || "Fout bij testen Doorsy verbinding"
    });
    
    return { type: "DOORSY_ERROR", error: error.message };
  }
};

// Haal Doorsy gebruiker informatie op
export const fetchDoorsyUserInfo = () => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(`${DOORSY_API_URL}/user-info`, {
      method: 'GET',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      }
    });
    
    const data = await handleResponse(response);
    
    dispatch({
      type: FETCH_DOORSY_USER_INFO,
      payload: data.data
    });
    
    return data;
  } catch (error) {
    dispatch({
      type: DOORSY_ERROR,
      payload: error.message || "Fout bij ophalen Doorsy gebruiker informatie"
    });
    
    return { type: "DOORSY_ERROR", error: error.message };
  }
};

// Haal Doorsy systeem informatie op
export const fetchDoorsySystemInfo = () => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(`${DOORSY_API_URL}/system-info`, {
      method: 'GET',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      }
    });

    const data = await handleResponse(response);

    dispatch({
      type: FETCH_DOORSY_SYSTEM_INFO,
      payload: data.data
    });

    return data;
  } catch (error) {
    dispatch({
      type: DOORSY_ERROR,
      payload: error.message || "Fout bij ophalen Doorsy systeem informatie"
    });

    return { type: "DOORSY_ERROR", error: error.message };
  }
};

// Haal Doorsy realestates op
export const fetchDoorsyRealestates = () => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(`${DOORSY_API_URL}/realestates`, {
      method: 'GET',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      }
    });

    const data = await handleResponse(response);

    dispatch({
      type: FETCH_DOORSY_REALESTATES,
      payload: data.data
    });

    return data;
  } catch (error) {
    dispatch({
      type: DOORSY_ERROR,
      payload: error.message || "Fout bij ophalen Doorsy realestates"
    });

    return { type: "DOORSY_ERROR", error: error.message };
  }
};

// Maak nieuwe Doorsy realestate aan
export const createDoorsyRealestate = (realestateData) => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(`${DOORSY_API_URL}/realestates`, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(realestateData)
    });

    const data = await handleResponse(response);

    dispatch({
      type: CREATE_DOORSY_REALESTATE,
      payload: data.data
    });

    return data;
  } catch (error) {
    dispatch({
      type: DOORSY_ERROR,
      payload: error.message || "Fout bij aanmaken Doorsy realestate"
    });

    return { type: "DOORSY_ERROR", error: error.message };
  }
};

// =============== TOEGANGSCODE ACTIONS ===============

// Maak nieuwe toegangscode aan via Doorsy API
export const createToegangsCode = (codeData) => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(`${DOORSY_API_URL}/access-control`, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(codeData)
    });

    const data = await handleResponse(response);

    dispatch({
      type: CREATE_TOEGANGSCODE,
      payload: data.data
    });

    return data;
  } catch (error) {
    dispatch({
      type: TOEGANGSCODE_ERROR,
      payload: error.message || "Fout bij aanmaken toegangscode"
    });

    return { type: "TOEGANGSCODE_ERROR", error: error.message };
  }
};

// Haal alle toegangscodes op via Doorsy API
export const fetchToegangsCode = (filters = {}) => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    const queryParams = new URLSearchParams(filters).toString();
    const url = queryParams ? `${DOORSY_API_URL}/access-control?${queryParams}` : `${DOORSY_API_URL}/access-control`;

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      }
    });

    const data = await handleResponse(response);

    dispatch({
      type: FETCH_TOEGANGSCODES,
      payload: data.data
    });

    return data;
  } catch (error) {
    dispatch({
      type: TOEGANGSCODE_ERROR,
      payload: error.message || "Fout bij ophalen toegangscodes"
    });

    return { type: "TOEGANGSCODE_ERROR", error: error.message };
  }
};

// Haal specifieke toegangscode op
export const fetchToegangsCodeById = (id) => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(`${TOEGANGSCODE_API_URL}/${id}`, {
      method: 'GET',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      }
    });

    const data = await handleResponse(response);

    dispatch({
      type: FETCH_TOEGANGSCODE,
      payload: data.data
    });

    return data;
  } catch (error) {
    dispatch({
      type: TOEGANGSCODE_ERROR,
      payload: error.message || "Fout bij ophalen toegangscode"
    });

    return { type: "TOEGANGSCODE_ERROR", error: error.message };
  }
};

// Deactiveer toegangscode
export const deactiveerToegangsCode = (id) => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(`${TOEGANGSCODE_API_URL}/${id}/deactiveer`, {
      method: 'PUT',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      }
    });

    const data = await handleResponse(response);

    dispatch({
      type: DEACTIVEER_TOEGANGSCODE,
      payload: data.data
    });

    return data;
  } catch (error) {
    dispatch({
      type: TOEGANGSCODE_ERROR,
      payload: error.message || "Fout bij deactiveren toegangscode"
    });

    return { type: "TOEGANGSCODE_ERROR", error: error.message };
  }
};

// Verwijder toegangscode
export const deleteToegangsCode = (id) => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(`${TOEGANGSCODE_API_URL}/${id}`, {
      method: 'DELETE',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      }
    });

    const data = await handleResponse(response);

    dispatch({
      type: DELETE_TOEGANGSCODE,
      payload: id
    });

    return data;
  } catch (error) {
    dispatch({
      type: TOEGANGSCODE_ERROR,
      payload: error.message || "Fout bij verwijderen toegangscode"
    });

    return { type: "TOEGANGSCODE_ERROR", error: error.message };
  }
};

// Valideer toegangscode (publieke endpoint)
export const validateToegangsCode = (code) => async (dispatch) => {
  try {
    const response = await fetch(`/api/toegangscodes/validate/${code}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });

    const data = await handleResponse(response);

    dispatch({
      type: VALIDATE_TOEGANGSCODE,
      payload: data.data
    });

    return data;
  } catch (error) {
    dispatch({
      type: TOEGANGSCODE_ERROR,
      payload: error.message || "Fout bij valideren toegangscode"
    });

    return { type: "TOEGANGSCODE_ERROR", error: error.message };
  }
};

// Haal toegangscodes overzicht op
export const fetchToegangsCodesOverzicht = () => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(`${DOORSY_API_URL}/toegangscodes`, {
      method: 'GET',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      }
    });

    const data = await handleResponse(response);

    dispatch({
      type: 'FETCH_TOEGANGSCODES_OVERZICHT_SUCCESS',
      payload: data.data
    });

    return data;

  } catch (error) {
    const errorMsg = error.message || 'Fout bij ophalen toegangscodes overzicht';

    dispatch({
      type: TOEGANGSCONTROLE_ERROR,
      payload: errorMsg
    });

    throw error;
  }
};

// Controleer status van toegangscode
export const checkToegangsCodeStatus = (uuid) => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(`${DOORSY_API_URL}/toegangscodes/${uuid}/status`, {
      method: 'GET',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      }
    });

    const data = await handleResponse(response);

    dispatch({
      type: 'CHECK_TOEGANGSCODE_STATUS_SUCCESS',
      payload: { uuid, status: data.data }
    });

    return data;

  } catch (error) {
    const errorMsg = error.message || 'Fout bij controleren toegangscode status';

    dispatch({
      type: TOEGANGSCONTROLE_ERROR,
      payload: errorMsg
    });

    throw error;
  }
};

// Synchroniseer toegangscode data
export const syncToegangsCodesData = () => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(`${DOORSY_API_URL}/sync-toegangscodes`, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      }
    });

    const data = await handleResponse(response);

    dispatch({
      type: 'SYNC_TOEGANGSCODES_SUCCESS',
      payload: data
    });

    return { success: true, data };
  } catch (error) {
    console.error('Error syncing toegangscodes data:', error);

    dispatch({
      type: DOORSY_ERROR,
      payload: error.message || 'Fout bij synchroniseren van data'
    });

    throw error;
  }
};

// Stuur code naar Doorsy systeem
export const sendCodeToDoorsy = (codeId) => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(`${DOORSY_API_URL}/toegangscodes/${codeId}/send-to-doorsy`, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      }
    });

    const data = await handleResponse(response);

    dispatch({
      type: 'SEND_CODE_TO_DOORSY_SUCCESS',
      payload: data
    });

    return { success: true, data };
  } catch (error) {
    console.error('Error sending code to Doorsy:', error);

    dispatch({
      type: DOORSY_ERROR,
      payload: error.message || 'Fout bij versturen code naar Doorsy'
    });

    throw error;
  }
};

// Stuur bestaande toegangscode van gastenverbruik naar Doorsy
export const sendExistingCodeToDoorsy = (data) => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");

    // Controleer of er een bestaande code is
    if (!data.existingCode) {
      throw new Error('Geen bestaande toegangscode gevonden');
    }

    // Valideer dat de code precies 5 cijfers is
    if (!/^\d{5}$/.test(String(data.existingCode))) {
      throw new Error('Toegangscode moet precies 5 cijfers zijn');
    }

    // Format dates to YYYY-MM-DD format for Doorsy API
    const formatDateForDoorsy = (date) => {
      if (!date) return null;
      const d = new Date(date);
      return d.toISOString().split('T')[0]; // YYYY-MM-DD format
    };

    const formattedStartDate = formatDateForDoorsy(data.startDate);
    const formattedEndDate = formatDateForDoorsy(data.endDate);

    // Stuur bestaande code naar Doorsy API (server haalt configuratie op uit database)
    const doorsyResponse = await fetch(`${DOORSY_API_URL}/access-control`, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        pins: [data.existingCode],
        startDate: formattedStartDate,
        endDate: formattedEndDate,
        metadata: {
          beschrijving: data.beschrijving,
          gastenverbruik_id: data.gastenverbruik_id
        }
      })
    });

    if (!doorsyResponse.ok) {
      throw new Error('Fout bij verzenden naar Doorsy systeem');
    }

    const doorsyData = await doorsyResponse.json();



    dispatch({
      type: 'SEND_EXISTING_CODE_TO_DOORSY_SUCCESS',
      payload: {
        doorsy: doorsyData
      }
    });

    return {
      success: true,
      code: data.existingCode,
      doorsy: doorsyData
    };

  } catch (error) {
    console.error('Error sending existing code to Doorsy:', error);

    dispatch({
      type: TOEGANGSCODE_ERROR,
      payload: error.message || 'Fout bij verzenden code naar Doorsy'
    });

    throw error;
  }
};

// Verwijder toegangscode volledig (zowel van Doorsy API als database)
export const deleteToegangsCodeVolledig = (codeId) => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(`${DOORSY_API_URL}/toegangscodes/${codeId}/delete-volledig`, {
      method: 'DELETE',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      }
    });
    const data = await handleResponse(response);
    dispatch({
      type: 'DELETE_TOEGANGSCODE_VOLLEDIG_SUCCESS',
      payload: data
    });
    return { success: true, data };
  } catch (error) {
    console.error('Error deleting toegangscode:', error);
    dispatch({
      type: DOORSY_ERROR,
      payload: error.message || 'Fout bij verwijderen toegangscode'
    });
    throw error;
  }
};